/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TarificationDto } from './TarificationDto';
import {
    TarificationDtoFromJSON,
    TarificationDtoFromJSONTyped,
    TarificationDtoToJSON,
    TarificationDtoToJSONTyped,
} from './TarificationDto';

/**
 * 
 * @export
 * @interface CustomContractResponseDto
 */
export interface CustomContractResponseDto {
    /**
     * Indicates whether the contract processing was successful
     * @type {boolean}
     * @memberof CustomContractResponseDto
     */
    isSuccess: boolean;
    /**
     * Unique identifier for the tunnel process
     * @type {string}
     * @memberof CustomContractResponseDto
     */
    tunnelId: string;
    /**
     * 
     * @type {TarificationDto}
     * @memberof CustomContractResponseDto
     */
    tarification: TarificationDto;
    /**
     * Error message if the processing failed
     * @type {string}
     * @memberof CustomContractResponseDto
     */
    errorMessage?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomContractResponseDto
     */
    warningMessages?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomContractResponseDto
     */
    warningGuaranteesMessages?: Array<string>;
}

/**
 * Check if a given object implements the CustomContractResponseDto interface.
 */
export function instanceOfCustomContractResponseDto(value: object): value is CustomContractResponseDto {
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('tunnelId' in value) || value['tunnelId'] === undefined) return false;
    if (!('tarification' in value) || value['tarification'] === undefined) return false;
    return true;
}

export function CustomContractResponseDtoFromJSON(json: any): CustomContractResponseDto {
    return CustomContractResponseDtoFromJSONTyped(json, false);
}

export function CustomContractResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomContractResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isSuccess': json['isSuccess'],
        'tunnelId': json['tunnelId'],
        'tarification': TarificationDtoFromJSON(json['tarification']),
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'warningMessages': json['warningMessages'] == null ? undefined : json['warningMessages'],
        'warningGuaranteesMessages': json['warningGuaranteesMessages'] == null ? undefined : json['warningGuaranteesMessages'],
    };
}

export function CustomContractResponseDtoToJSON(json: any): CustomContractResponseDto {
    return CustomContractResponseDtoToJSONTyped(json, false);
}

export function CustomContractResponseDtoToJSONTyped(value?: CustomContractResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isSuccess': value['isSuccess'],
        'tunnelId': value['tunnelId'],
        'tarification': TarificationDtoToJSON(value['tarification']),
        'errorMessage': value['errorMessage'],
        'warningMessages': value['warningMessages'],
        'warningGuaranteesMessages': value['warningGuaranteesMessages'],
    };
}

